function getLoggedIn () {
	return Scipio.isLoggedIn();
}

function wdgGetSavedCustomer () {
	return Scipio.GetSavedCustomer();
}
